export default __webpack_public_path__ + "static/media/datatrust_id.590a0109.csv";